import styled from 'styled-components';

const shouldForwardProp = (prop) => ![].includes(prop);

export const LabelWrapper = styled.div`
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
`;

export const Label = styled.label`
  margin: 0;
  padding: 0;
  color: ${(props) => {
    if (props.disabled) {
      return 'var(--coolGray-400) !important';
    }

    if (props.invalid) {
      return 'var(--pink-900) !important';
    }

    return 'var(--coolGray-600)';
  }};
  font-weight: 600;
`;

export const Optional = styled.span`
  margin-top: 3px;
  font-size: 12px;
  color: var(--coolGray-400);
`;

export const ElementWrapper = styled.div`
  > * {
    width: 100%;
  }
`;

export const Hint = styled.p`
  margin: 0;
  color: var(--coolGray-500);
  font-size: 14px;
`;

export const Wrapper = styled('div').withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 400px;
  margin: 0;
  padding: 0;
  border: 0;

  &:focus-within {
    ${Label} {
      color: var(--blue-900);
    }
  }
`;
